import { ConfigPartnershipCard } from '@core/models/configPartnershipCard';
import { ConfiguratorIntegrations } from '@models';
import { createAction, props } from '@ngrx/store';

export enum ConfiguratorActions {
  SetConfiguratorPartnership = '[Flow Data Configurator] Set partnership',
}

export const SetConfiguratorPartnership = createAction(
  ConfiguratorActions.SetConfiguratorPartnership,
  props<{ data: ConfigPartnershipCard }>()
);
